const initialState = { 
  loading: false,
  payload: null,
  page: 1,
  pages: 1,
  limit: 10,
  stars: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  error: null
}


function listReviewProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'LIST_REVIEW_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'LIST_REVIEW_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        page: action.page,
        pages: action.pages,
        limit: action.limit,
        stars: action.stars,
        payload: action.payload
      }

    case 'LIST_REVIEW_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default listReviewProductReducer
